<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <router-link
      v-if="collapse"
      key="collapse"
      class="sidebar-logo-link"
      to="/"
    >
      <svg-icon icon-class="logo-mini" class="sidebar-logo"/>
    </router-link>
    <router-link v-if="!collapse" key="expand" class="sidebar-logo-link" to="/">
      <img src="/static/img/logo-white.png" class="img-logo"/>
    </router-link>
    <div v-if="!collapse&&userInfo&&userInfo.type=='USER'" class="message">
      <div>
        <span class="name">
          <strong>{{ name }}</strong>
        </span>
        <div class="price">
          <span class="text-muted">My Balance</span>
          <span class="text-muted">$ {{ userInfo.balance }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["name", "userInfo"]),
  },
  data() {
    return {
      title: "Honest FulPhilment",
    };
  },
};
</script>
<style lang="scss">
@import "@//styles/variables.scss";

.box .el-tabs__item {
  font-weight: $menuFontWeight;
}
</style>
<style lang="scss" scoped>
@import "@//styles/variables.scss";

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 140px;
  background: $menuBg;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    line-height: 80px;
    overflow: hidden;

    & .sidebar-logo {
      width: 40px;
      height: 40px;
      vertical-align: middle;
      margin-right: 10px;
      margin-left: 20px;
      border-radius: 6px;
    }

    & .img-logo {
      height: 48px;
      vertical-align: middle;
      margin-top: 10px;
      border-radius: 6px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: $menuText;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    height: 100px;

    .sidebar-logo {
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      padding: 7px 5px;
      margin: 0 !important;
      background: #fff;
      border-radius: 8px;
    }
  }
}

.message {
  position: absolute;
  top: 70px;
  left: 0;
  width: 100%;
  z-index: 9999;
  color: $menuText;
  font-size: 13px;
  padding-left: 10px;

  .name {
    width: 100%;
    margin-top: 5px;
    color: $menuText;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .price {
    display: flex;
    justify-content: space-between;
    padding-right: 30px;
    padding-left: 18px;
  }

  span {
    color: $menuText;
    font-size: 13px;
    margin-top: 8px;
  }
}

strong {
  height: 100%;
  font-size: 18px;
  position: relative;
  color: #ffffff;
}

.panel {
  position: absolute;
  bottom: 10px;
  left: 0;
  height: 30px;
  width: 100%;

  .box {
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-around;
    position: relative;
  }
}

.rotate {
  width: 35%;
  cursor: pointer;
  font-size: 14px;
  color: $menuText;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-bottom: 3px solid #100a09;
}

.action {
  border-bottom: 3px solid $main-color !important;
}

.rotateX {
  width: 35%;
  font-size: 14px;
  color: $menuText;
  cursor: pointer;
  justify-content: center;
  display: flex;
  height: 100%;
  align-items: center;
}
</style>
